import { DatePicker } from 'components/Form'

type Props = {
	value: Date
	onChange(value: Date): void
	onBlur(): void
	loading: boolean
}

export const DateEditableCell = ({ value, onChange, onBlur, loading }: Props) => {
	return (
		<DatePicker
			value={value}
			onChange={onChange}
			onBlur={onBlur}
			loading={loading}
			size='small'
		/>
	)
}
